const API_URL = process.env.VUE_APP_API_URL+'/office'

import { userService } from './userServices.js';
//import { acService } from './AcApi.js';

export const geoApi = {
    getGeoJson,getGeoJsonBlk,
    getMarkers,
    getComuInfo,
    getMarkerInfo,getAcMarkers,getGeoJsonByBlkId

};

function getComuInfo() {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune })
    };


    return fetch(API_URL + '/geo/getComuInfo', requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
               // alert(' user service'+JSON.stringify(ret));
                return ret;
            }
            return 'errore';
        });
}




function getGeoJsonByBlkId(blkId) {
    
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, blkId })
    };
    
    return fetch(API_URL + '/geo/getGeoJsonByBlkId', requestOptions).then(userService.handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {
               // setMap(mapStorage,key, JSON.stringify(ret));
               
               //ret=JSON.parse(ret);
              // alert("getGeoJsonBLK:"+JSON.stringify(ret));
                return ret;
            }

            return 'errore';
        });
}

function getGeoJsonBlk(shapeName) {
    
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, shapeName })
    };
    
    return fetch(API_URL + '/geo/getGeoJsonBlk', requestOptions).then(userService.handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {
               // setMap(mapStorage,key, JSON.stringify(ret));
               
               //ret=JSON.parse(ret);
               
                return ret.geoBlk;
            }

            return 'errore';
        });
}
function getGeoJson(shapeName) {
    
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, shapeName })
    };
    
    return fetch(API_URL + '/geo/getGeoJson', requestOptions).then(userService.handleResponse)
        .then(ret => {
            // login successful if there's a jwt token in the response

            if (ret) {
               // setMap(mapStorage,key, JSON.stringify(ret));
               //alert("getGeoJson:"+JSON.stringify(ret));
                return ret;
            }

            return 'errore';
        });
}
function getAcMarkers(prgAc,tipoMarker) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgAc,tipoMarker })
    };


    return fetch(API_URL + '/geo/getMarkers', requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        });
}
function getMarkers(tipoMarker) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune ,tipoMarker})
    };


    return fetch(API_URL + '/geo/getMarkers', requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        });
}
function getMarkerInfo(marker) {
    
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, marker })
    };


    return fetch(API_URL + '/geo/getMarkerInfo', requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                return ret;
            }
            return 'errore';
        });
}


